import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import Discountbar from "../Discountbar/Discountbar";
import HeaderTopbar from "../HeaderTopbar/HeaderTopbar";
import HeaderMiddle from "../HeaderMiddle/HeaderMiddle";
import SearchModal from "../Modal/SearchModal";
import { connect } from "react-redux";
import { Box, Button, Dialog, Divider, Drawer, ListItem, ListItemButton, ListItemIcon, ListItemText, Modal, Typography } from "@mui/material";
import { logout } from "../../store/actions/action";
import Slider from "react-slick";
import TouchRipple from "@mui/material/ButtonBase/TouchRipple";
import { List } from "reactstrap";
import Logo from "../UiStyle/Logo";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const Header = (props) => {
  const [categoryActive, setcategoryState] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location?.pathname === "/";
  const isShop = location?.pathname === "/shop";
  const isOrders = location?.pathname === "/your-orders";

  const openLogoutModal = () => {
    setLogoutModal(true);
  };
  const closeLogoutModal = () => {
    setLogoutModal(false);
  };
  const { configs } = props;
  const { isAuth, token } = configs;

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const handleCategoryClick = (category) => {
    // Create URLSearchParams object
    const searchParams = new URLSearchParams();
    searchParams.set("category", category);

    // Navigate to the new route with the updated query params
    navigate(`/shop?${searchParams.toString()}`);
    setcategoryState(false);
  };

  const settings = {
    dots: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: TouchRipple,
        },
      },
    ],
  };
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const menuItems = [
    { text: "All offers", href: "/shop", id: 1, status: true },
    { text: "gaming", href: "/shop", id: 2, status: true },
    { text: "retail", href: "/shop", id: 3, status: true },
    { text: "travel", href: "/shop", id: 4, status: true },
    // { text: "e-sim", href: "/shop", id: 4, status: false },
    { text: "mobile recharge", href: "/mobile-recharge", id: 4, status: false },
  ];
  const DrawerList = (
    <Box sx={{ width: 300, padding: "10px 10px" }} className="" role="presentation" onClick={toggleDrawer(false)}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "5px",
          boxShadow: "rgba(199, 191, 191, 0.02) 0px 1px 3px 0px, rgba(211, 213, 214, 0.15) 0px 0px 0px 1px;",
        }}
        className="sidebar-logo-bg"
      >
        <Logo to={"/"} className="navbar-brand" />
        <Box sx={{ cursor: "pointer", padding: "5px" }} className="">
          <CloseIcon />
        </Box>
      </Box>
      <List>
        {menuItems?.map((text, index) => (
          <ListItem key={text.id} disablePadding>
            <ListItemButton component="a" href={text.href} sx={{ textTransform: "capitalize", fontWeight: "550" }} className="">
              <ListItemText primary={text.text} />
              {text.status ? <ArrowForwardIosIcon fontSize="small" /> : <span className="new-sidebar-world">new</span>}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <>
      <div className="main-header-wrap">
        {/* <Discountbar />
        <HeaderTopbar /> */}
        <header className={`header-area ${props.hclass}`}>
          <HeaderMiddle />
          <div id="header-sticky" className="menu-area">
            <div className="container-header-new">
              <div>
                <Button
                  onClick={toggleDrawer(true)}
                  sx={{
                    color: "white",
                    display: "flex",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                  className=""
                >
                  {" "}
                  <MenuIcon className="" sx={{ marginRight: "9px" }} /> Categories
                </Button>

                {/* <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Retail
                </Box>
                <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Ecommerece
                </Box>
                <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Entertainment
                </Box>
                <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Travel
                </Box>
                <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Hamper
                </Box> */}
                <Box
                  onClick={() => {
                    navigate("/mobile-recharge");
                  }}
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Mobile Recharges
                </Box>
                {/* <Box
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  E-SIM
                </Box> */}

                <Box
                  onClick={() => {
                    navigate("/shop");
                  }}
                  sx={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.06)",
                      color: "#20d5ba",
                      transform: "scale(1.05)",
                      transition: "all 0.3s ease",
                    },
                  }}
                >
                  Gaming
                </Box>
              </div>
            </div>
          </div>
        </header>
      </div>

      <Drawer
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: "#034142", // Set the background color
            color: "#ffffff", // Optional: Set text color
          },
        }}
        open={open}
        onClose={toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>

      <SearchModal />
      <Modal open={logoutModal} onClose={closeLogoutModal} aria-labelledby="logout-modal-title" aria-describedby="logout-modal-description">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            p: 2,
            textAlign: "center",
          }}
        >
          <Typography sx={{ textAlign: "left" }} id="logout-modal-title" variant="h4" component="h2">
            Confirm Logout
          </Typography>
          <Typography
            id="logout-modal-description"
            sx={{ mt: 2, mb: 2, textAlign: "left" }}
            // variant="body"
          >
            Are you sure you want to log out?
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              mt: 3,
              gap: 2,
            }}
          >
            <Button variant="outlined" color="secondary" onClick={closeLogoutModal} sx={{ width: "100%", py: "10px" }}>
              Cancel
            </Button>
            <Button
              sx={{ width: "100%", py: "10px" }}
              variant="contained"
              color="error"
              onClick={() => {
                props?.logout();
                closeLogoutModal();
              }}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
    w_list: state.wishList.w_list,
    configs: state.configs,
  };
};
export default connect(mapStateToProps, { logout })(Header);
